<template>
  <div class="user-info">
    <div class="user-info-top" v-if="showUserInfoTop" :class="{ 'noPrint': !showFirstLine }">
      <div class="user-info-top-left" :class="userClasses">
        <!-- 慧疗互联网医院定制：报告医生（写死）+ 审核电子签名 -->
        <template v-if="model.reportTemplateType === 51">
          <p class="user-info-top-left-text" style="margin-right: 40px;">
            报告：<span class="bottom-line">浙江省人民医院耳鼻喉科冯佳鹏</span>
          </p>
          <p class="user-info-top-left-text" style="margin-right: 40px;">
            审核：<img
              src="https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/94a8d03a9d51cb9a51529b42e754c98f.jpg"
              alt="" style="height: 30px;">
          </p>
        </template>
        <template v-else>
          <line-input v-if="showReporter" :title="reporterTitle" :initalValue="reporterInitialValue"
            @onInput="onInputInput"></line-input>
          <line-input v-if="showReviewer" :title="reviewerTitle" :initalValue="model.initialReviewer"
            @onInput="onInputInput"></line-input>
        </template>
        <button v-if="showInlineSaveButton" class="user-info-top-left-button noPrint" data-html2canvas-ignore="true"
          @click="onSaveClick">
          保存
        </button>
      </div>
      <div style="flex: 1"></div>
      <p v-if="showCreateDate" class="user-info-top-right">
        {{ model.createDate }}
      </p>
    </div>
    <!-- 广东省人民医院珠海医院呼吸科 -->
    <div v-if="model.reportTemplateType == 14">
      <div class="user-info-bottom">
        <new-line-input title="姓名" :initalValue="model.initialPatientName" :maxWidth="210"
          @onInput="onInputInput"></new-line-input>
        <line-input title="年龄" :initalValue="patientAgeDisplay" @onInput="onInputInput"></line-input>
        <line-input title="性别" :initalValue="model.initialPatientGender" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="病案号" :initalValue="model.initialPatientDiagnoseNumber" @onInput="onInputInput"></line-input>
        <line-input title="床位号" :initalValue="model.initialPatientBedNumber" @onInput="onInputInput"></line-input>
        <line-input title="科室" :initalValue="model.initialPatientDepartment" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="身高(cm)" :initalValue="model.initialPatientHeight" @onInput="onInputInput"></line-input>
        <line-input title="体重(Kg)" :initalValue="model.initialPatientWeight" @onInput="onInputInput"></line-input>
        <line-input title="BMI" :initalValue="patientBMI" :isReadOnly="true" @onInput="onInputInput"></line-input>
      </div>
    </div>
    <!-- 东莞市松山湖中心医院 -->
    <div v-else-if="model.reportTemplateType == 47">
      <div class="user-info-bottom">
        <new-line-input title="姓名" :initalValue="model.initialPatientName" :maxWidth="210"
          @onInput="onInputInput"></new-line-input>
        <line-input title="性别" :initalValue="model.initialPatientGender" @onInput="onInputInput"></line-input>
        <line-input title="年龄" :initalValue="patientAgeDisplay" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="病案号" :initalValue="model.initialPatientDiagnoseNumber" @onInput="onInputInput"></line-input>
        <line-input title="科室" :initalValue="model.initialPatientDepartment" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="身高(cm)" :initalValue="model.initialPatientHeight" @onInput="onInputInput"></line-input>
        <line-input title="体重(Kg)" :initalValue="model.initialPatientWeight" @onInput="onInputInput"></line-input>
        <line-input title="BMI" :initalValue="patientBMI" :isReadOnly="true" @onInput="onInputInput"></line-input>
      </div>
    </div>
    <!-- 襄阳市中心医院神经内科睡眠中心 -->
    <div v-else-if="model.reportTemplateType == 48">
      <div class="user-info-bottom">
        <line-input title="科室" :initalValue="model.initialPatientDepartment" @onInput="onInputInput"></line-input>
        <new-line-input title="姓名" :initalValue="model.initialPatientName" :maxWidth="210"
          @onInput="onInputInput"></new-line-input>
        <line-input title="住院号" :initalValue="model.initialPatientDiagnoseNumber" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="年龄" :initalValue="patientAgeDisplay" @onInput="onInputInput"></line-input>
        <line-input title="性别" :initalValue="model.initialPatientGender" @onInput="onInputInput"></line-input>
        <line-input title="床号" :initalValue="model.bch" @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="身高(cm)" :initalValue="model.initialPatientHeight" @onInput="onInputInput"></line-input>
        <line-input title="体重(Kg)" :initalValue="model.initialPatientWeight" @onInput="onInputInput"></line-input>
        <line-input title="BMI" :initalValue="patientBMI" :isReadOnly="true" @onInput="onInputInput"></line-input>
      </div>
    </div>
    <!-- 台州恩泽医疗中心集团恩泽医院 -->
    <div v-else-if="model.reportTemplateType == 3">
      <div class="user-info-bottom">
        <line-input title="姓名" :initalValue="model.initialPatientName" @onInput="onInputInput"></line-input>
        <line-input title="身高(cm)" :initalValue="model.initialPatientHeight" @onInput="onInputInput"></line-input>
        <line-input title="年龄" :initalValue="patientAgeDisplay" @onInput="onInputInput"></line-input>
        <line-input title="病案号" class="user-info-bottom-max" :initalValue="model.initialPatientDiagnoseNumber"
          @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="性别" :initalValue="model.initialPatientGender" @onInput="onInputInput"></line-input>
        <line-input title="体重(Kg)" :initalValue="model.initialPatientWeight" @onInput="onInputInput"></line-input>
        <line-input title="BMI" class="user-info-bottom-min" :initalValue="patientBMI" :isReadOnly="true"
          @onInput="onInputInput"></line-input>
        <line-input title="科室" class="user-info-bottom-max" :initalValue="model.initialPatientDepartment"
          @onInput="onInputInput"></line-input>
      </div>
    </div>
    <div v-else-if="model.reportTemplateType == 34">

      <div class="user-info-bottom">
        <line-input title="姓名" :initalValue="model.initialPatientName" @onInput="onInputInput"></line-input>

        <line-input :title="model.reportTemplateType !== 34 ? '年龄' : '年龄(岁)'" class="user-info-bottom-min"
          :initalValue="patientAgeDisplay" @onInput="onInputInput"></line-input>
        <!-- <line-input
          title="病案号"
          class="user-info-bottom-max"
          :initalValue="model.initialPatientDiagnoseNumber"
          @onInput="onInputInput"
        ></line-input> -->
        <line-input title="性别" :initalValue="model.initialPatientGender" @onInput="onInputInput"></line-input>

      </div>
      <div class="user-info-bottom">
        <line-input title="身高(cm)" class="user-info-bottom-wider" :initalValue="model.initialPatientHeight"
          @onInput="onInputInput"></line-input>
        <!-- <line-input
          title="性别"
          :initalValue="model.initialPatientGender"
          @onInput="onInputInput"
        ></line-input> -->
        <line-input title="体重(Kg)" :initalValue="model.initialPatientWeight" @onInput="onInputInput"></line-input>
        <line-input title="BMI" :initalValue="patientBMI" :isReadOnly="true" @onInput="onInputInput"></line-input>
        <line-input :title="model.reportTemplateType !== 34 ? '血压' : '血压(mmHg)'" :initalValue="model.bloodPressure"
          @onInput="onInputInput"></line-input>
        <!-- <line-input
          title="科室"
          class="user-info-bottom-max"
          :initalValue="model.initialPatientDepartment"
          @onInput="onInputInput"
        ></line-input> -->
      </div>
      <div class="user-info-bottom">
        <line-input title="科室" class="user-info-bottom-wider" :initalValue="model.initialPatientDepartment"
          @onInput="onInputInput"></line-input>
        <line-input title="病区床号" :initalValue="model.bch" @onInput="onInputInput"></line-input>
        <line-input title="病案号" :initalValue="model.initialPatientDiagnoseNumber" @onInput="onInputInput"></line-input>
        <line-input :title="model.reportTemplateType !== 34 ? '颈围' : '颈围(cm)'"
          :initalValue="model.initialPatientNeckCircumference" @onInput="onInputInput"></line-input>
      </div>
      <!-- <div class="user-info-bottom">
        <line-input
          title="颈围"
         
          :initalValue="model.initialPatientNeckCircumference"
          @onInput="onInputInput"
        ></line-input>
        <line-input
          title="血压"
         
          :initalValue="model.bloodPressure"
          @onInput="onInputInput"
        ></line-input>
       
      </div> -->
    </div>
    <div v-else>
      <div class="user-info-bottom">
        <new-line-input title="姓名" :initalValue="model.initialPatientName" :maxWidth="425"
          :class="{ 'user-info-bottom-center': model.reportTemplateType === 38 }"
          @onInput="onInputInput"></new-line-input>
        <line-input title="性别" :initalValue="model.initialPatientGender"
          :class="{ 'user-info-bottom-center': model.reportTemplateType === 38 }" @onInput="onInputInput"></line-input>
        <line-input title="床号" :initalValue="model.bch" @onInput="onInputInput"
          v-if="model.reportTemplateType == 41"></line-input>
      </div>
      <div class="user-info-bottom" :class="{ 'user-info-bottom-four-columns': isYunfuReport }">
        <line-input :title="ageTitle" :initalValue="patientAgeDisplay"
          :class="[{ 'user-info-bottom-age-narrow': showMzh && model.reportTemplateType !== 38 }, { 'user-info-bottom-center': model.reportTemplateType === 38 }]"
          @onInput="onInputInput"></line-input>
        <line-input v-if="showMzh" :title="mzhTitle" :initalValue="model.initialPatientDiagnoseNumber"
          :class="[{ 'user-info-bottom-mzh-wide': model.reportTemplateType !== 38 }, { 'user-info-bottom-center': model.reportTemplateType === 38 }]"
          @onInput="onInputInput"></line-input>
        <!-- 江门市人民医院耳鼻喉科 -->
        <line-input v-if="model.reportTemplateType == 10" title="手机号" :initalValue="model.initInitialMobile"
          @onInput="onInputInput"></line-input>
        <line-input v-else title="科室"
          :class="['user-info-bottom-wider', { 'user-info-bottom-center': model.reportTemplateType === 38 }]"
          :initalValue="departmentValue" @onInput="onInputInput"></line-input>
        <line-input v-if="isYunfuReport" title="床位号" :initalValue="model.initialPatientBedNumber || ''"
          @onInput="onInputInput"></line-input>
      </div>
      <div class="user-info-bottom">
        <line-input title="身高(cm)"
          :class="['user-info-bottom-wider', { 'user-info-bottom-center': model.reportTemplateType === 38 }]"
          :initalValue="model.initialPatientHeight" @onInput="onInputInput"></line-input>
        <line-input :title="isYunfuReport ? '体重(kg)' : '体重(Kg)'" :initalValue="model.initialPatientWeight"
          :class="{ 'user-info-bottom-center': model.reportTemplateType === 38 }" @onInput="onInputInput"></line-input>
        <line-input :title="bmiTitle" :initalValue="patientBMI" :isReadOnly="true"
          :class="{ 'user-info-bottom-center': model.reportTemplateType === 38 }" @onInput="onInputInput"></line-input>

      </div>

      <div class="user-info-bottom" v-if="showOtherInfo1">
        <line-radio title="AR" :initalValue="model.initialAR" :options="['有', '无']"
          @onInput="onInputInput"></line-radio>
        <line-input style="padding-left: 1px; width: 105px;" title="腺样体" :initalValue="model.initialAdenoids"
          :maxLength="3" @onInput="onInputInput"></line-input>
        <line-input style="padding-left: 1px; width: 150px;" title="扁桃体" :initalValue="model.initialTonsils"
          :maxLength="6" @onInput="onInputInput"></line-input>
        <line-radio title="咽喉反流" style="padding-left: 1px;" :initalValue="model.initialThroatReflux"
          :options="['有', '无']" @onInput="onInputInput"></line-radio>
        <line-radio title="睡眠张口" style="padding-left: 1px;" :initalValue="model.initialSleepOpenMouth"
          :options="['有', '无']" @onInput="onInputInput"></line-radio>
        <line-radio title="过敏原" style="padding-left: 1px;" :initalValue="model.initialAllergen"
          :options="['户尘螨', '屋尘螨']" multiple @onInput="onInputInput"></line-radio>
      </div>
      <div class="user-info-bottom" v-if="showOtherInfo2">
        <line-input title="颈围(cm)" class="user-info-bottom-wider"
          :initalValue="model.initialPatientNeckCircumference" @onInput="onInputInput"></line-input>
        <line-input title="腰围(cm)" :initalValue="model.initialWaistCircumference" @onInput="onInputInput"></line-input>
        <div style="width: 30%;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import LineInput from "./line-input.vue";
import NewLineInput from "./new-line-input.vue";
import LineRadio from "./line-radio.vue";
export default {
  components: {
    LineInput,
    NewLineInput,
    LineRadio,
  },

  props: {
    patientBMI: String,
    model: Object,
  },
  computed: {
    isYunfuReport() {
      return this.model.reportTemplateType === REPORT_TEMPLATE.云浮市人民医院全科医学科睡眠医学中心;
    },

    bmiTitle() {
      return this.isYunfuReport ? "BMI(kg/m²)" : "BMI";
    },

    showReporter() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.台州恩泽医疗中心集团恩泽医院:
        case REPORT_TEMPLATE.舟山市第二人民医院:
        case REPORT_TEMPLATE.中山大学附属第三医院·河源市中医院耳鼻喉科·广州市第十二人民医院·中山大学附属第八医院耳鼻喉科:
        case REPORT_TEMPLATE.南方医科大学顺德医院耳鼻咽喉头颈外科:
        case REPORT_TEMPLATE.山东省精神卫生中心:
        case REPORT_TEMPLATE.广东省人民医院珠海医院呼吸科:
        case REPORT_TEMPLATE.温州医科大学附属第二医院:
        case REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科:
        case REPORT_TEMPLATE.深圳市龙华区中心医院耳鼻喉科:
        case REPORT_TEMPLATE.上海瑞金医院:
        case REPORT_TEMPLATE.台州市中心医院台州学院附属医院神经内科:
        case REPORT_TEMPLATE.佛山市南海区全科医院:
        case REPORT_TEMPLATE.福建医科大学附属协和医院:
        case REPORT_TEMPLATE.泰安市中医医院:
        case REPORT_TEMPLATE.湖州市第一人民医院儿科:
        case REPORT_TEMPLATE.襄阳市中心医院神经内科睡眠中心:
        case REPORT_TEMPLATE.中国医科大学附属盛京医院滑翔院区:
        case REPORT_TEMPLATE.广东省中医院二沙岛医院:
        case REPORT_TEMPLATE.云浮市人民医院全科医学科睡眠医学中心:
        case REPORT_TEMPLATE.临沂市中心医院精神卫生科:
          return false;
        default:
          return true;
      }
    },

    showReviewer() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.台州恩泽医疗中心集团恩泽医院:
        case REPORT_TEMPLATE.中山大学附属第三医院·河源市中医院耳鼻喉科·广州市第十二人民医院·中山大学附属第八医院耳鼻喉科:
        case REPORT_TEMPLATE.南方医科大学顺德医院耳鼻咽喉头颈外科:
        case REPORT_TEMPLATE.山东省精神卫生中心:
        case REPORT_TEMPLATE.广东省人民医院珠海医院呼吸科:
        case REPORT_TEMPLATE.温州医科大学附属第二医院:
        case REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科:
        case REPORT_TEMPLATE.深圳市龙华区中心医院耳鼻喉科:
        case REPORT_TEMPLATE.上海瑞金医院:
        case REPORT_TEMPLATE.台州市中心医院台州学院附属医院神经内科:
        case REPORT_TEMPLATE.佛山市南海区全科医院:
        case REPORT_TEMPLATE.福建医科大学附属协和医院:
        case REPORT_TEMPLATE.罗湖区妇幼保健院:
        case REPORT_TEMPLATE.泰安市中医医院:
        case REPORT_TEMPLATE.湖州市第一人民医院儿科:
        case REPORT_TEMPLATE.襄阳市中心医院神经内科睡眠中心:
        case REPORT_TEMPLATE.中国医科大学附属盛京医院滑翔院区:
        case REPORT_TEMPLATE.广东省中医院二沙岛医院:
        case REPORT_TEMPLATE.云浮市人民医院全科医学科睡眠医学中心:
        case REPORT_TEMPLATE.临沂市中心医院精神卫生科:
          return false;
        default:
          return true;
      }
    },

    showCreateDate() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.台州恩泽医疗中心集团恩泽医院:
        case REPORT_TEMPLATE.南方医科大学顺德医院耳鼻咽喉头颈外科:
        case REPORT_TEMPLATE.温州医科大学附属第二医院:
        case REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科:
        case REPORT_TEMPLATE.台州市中心医院台州学院附属医院神经内科:
        case REPORT_TEMPLATE.云浮市人民医院全科医学科睡眠医学中心:
          return false;
        default:
          return true;
      }
    },

    showUserInfoTop() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.广州暨华:
        case REPORT_TEMPLATE.东莞市松山湖中心医院:
          return false;
        default:
          return true;
      }
    },

    showInlineSaveButton() {
      return this.model.reportTemplateType !== REPORT_TEMPLATE.襄阳市中心医院神经内科睡眠中心;
    },

    reporterTitle() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.罗湖区妇幼保健院:
          return "报告医生";
        default:
          return "报告";
      }
    },

    reporterInitialValue() {
      if (this.model.reportTemplateType === REPORT_TEMPLATE.广西壮族自治区南溪山医院耳鼻喉科) {
        return '林贤俊';
      }
      return this.model.initialOperator;
    },

    reviewerTitle() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.舟山市第二人民医院:
          return "医师";
        default:
          return "审核";
      }
    },

    mzhTitle() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.山东省立医院集团鲁东医院:
          return "登记号";
        case REPORT_TEMPLATE.舟山市第二人民医院:
        case REPORT_TEMPLATE.南方医科大学顺德医院耳鼻咽喉头颈外科:
          return "住院号";
        case REPORT_TEMPLATE.南京市儿童医院:
        case REPORT_TEMPLATE.广东省中医院二沙岛医院:
          return "就诊卡号";
        case REPORT_TEMPLATE.深圳市龙华区中心医院耳鼻喉科:
          return '档案号'
        case REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科:
          return "住院号/登记号";
        default:
          return "病案号";
      }
    },

    showMzh() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.上海瑞金医院:
        case REPORT_TEMPLATE.中国医科大学附属盛京医院滑翔院区:
          return false;
        default:
          return true;
      }
    },

    ageTitle() {
      switch (this.model.reportTemplateType) {
        case REPORT_TEMPLATE.深圳市龙华区中心医院耳鼻喉科:
        case REPORT_TEMPLATE.广东省中医院二沙岛医院:
        case REPORT_TEMPLATE.云浮市人民医院全科医学科睡眠医学中心:
        case 38:
          return "年龄(岁)"
        default:
          return "年龄"
      }
    },

    userClasses() {
      return {
        "user-info-top-left-wide": this.model.reportTemplateType == REPORT_TEMPLATE.台州恩泽医疗中心集团恩泽医院,
        "user-info-top-left-wider": this.model.reportTemplateType == REPORT_TEMPLATE.罗湖区妇幼保健院,
        "user-info-top-left-extra-wide": this.model.reportTemplateType == REPORT_TEMPLATE.舟山市第二人民医院 || this.model.reportTemplateType == REPORT_TEMPLATE.山东省精神卫生中心,
      }
    },

    showFirstLine() {
      return this.showReporter || this.showReviewer || this.showCreateDate;
    },
    //增加一行临床症状：鼻，咽喉后面空位多一点。扁桃体和腺样体后面留4个字空间
    showOtherInfo1() {
      return this.model.reportTemplateType == REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科;
    },
    //增加一行 颈围：_____cm；腰围：_____cm
    showOtherInfo2() {
      return this.model.reportTemplateType == REPORT_TEMPLATE.广东省中医院二沙岛医院;
    },

    patientAgeDisplay() {
      if ((this.model.reportTemplateType === REPORT_TEMPLATE.深圳市南山区妇幼保健院耳鼻喉科 || this.model.reportTemplateType === REPORT_TEMPLATE.佛山复星禅城医院儿科二区) && this.model.initialPatientBirthday) {
        if (this.model.isEdit) {
          return this.model.initialPatientAge;
        }
        const birth = dayjs(this.model.initialPatientBirthday);
        if (birth.isValid()) {
          const now = dayjs();
          const years = now.diff(birth, 'year');
          const months = now.diff(birth.add(years, 'year'), 'month');
          if (years === 0) return `${months}月`;
          if (months === 0) return `${years}岁`;
          return `${years}岁${months}月`;
        }
      }
      return this.model.initialPatientAge;
    },

    departmentValue() {
      const templateType = this.model.reportTemplateType;

      switch (templateType) {
        case REPORT_TEMPLATE.佛山市南海区全科医院:
          return this.model.initialPatientDepartment || '呼吸内科、心血管内科';
        case 33:
          return '睡眠与心理卫生科';
        case 35:
          return '神经二科';
        case 38:
          return '睡眠心身科';
        case REPORT_TEMPLATE.广东省中医院二沙岛医院:
          return '二沙耳鼻咽喉头颈科';
        default:
          return this.model.initialPatientDepartment;
      }
    }
  },

  methods: {
    onInputInput(title, value) {
      console.log(title, value);
      this.$emit("onInputInput", title, value);
    },
    onSaveClick() {
      this.$emit("onSaveClick");
    },
  },

};
</script>

<style lang="scss" scoped>
.user-info {
  margin-bottom: rem(20);
  margin-top: rem(20);

  &-top {
    height: rem(40);
    margin-top: rem(10);
    margin-bottom: rem(10);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;

      .line-input {
        width: 27%;
      }

      &-text {
        color: black;
        font-size: rem(14);
        white-space: nowrap;
        padding-left: rem(20); // 与下方姓名等 line-input 左对齐

        img {
          border-bottom: 1px solid #333;
        }
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-left-wide {
      display: flex;
      align-items: center;
      margin-left: auto;

      .line-input {
        width: 27%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-left-wider {
      display: flex;
      align-items: center;

      .line-input {
        width: 55%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-left-extra-wide {
      display: flex;
      align-items: center;

      .line-input {
        width: 50%;
      }

      &-button {
        color: white;
        background-color: #16d585;
        font-size: rem(12);
        border-radius: rem(4);
        width: rem(50);
        height: rem(25);
        margin-left: rem(20);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &-right {
      color: black;
      font-size: rem(14);
      margin-right: rem(12);
      white-space: nowrap;
    }
  }

  .bottom-line {
    border-bottom: 1px solid #333;
  }

  &-bottom {
    width: 100%;
    height: rem(40);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .line-input {
      width: 30%;
    }

    .new-line-input {
      width: 30%;
    }

    &-min {
      width: 18% !important;
    }

    &-max {
      width: 50% !important;
    }

    &-wider {
      width: 35% !important;
    }

    // 病案号支持长号码（如19位住院号）完整显示：年龄缩窄、病案号加宽
    &-age-narrow {
      width: 25% !important;
    }

    &-mzh-wide {
      width: 35% !important;
    }

    &-four-columns {
      .line-input {
        width: 25% !important;
      }
    }

    &-center {
      text-align: center;
    }
  }
}

@media print {
  .noPrint {
    display: none;
    background-color: white !important;
  }
}
</style>
